import { Tag } from "antd";
import { useTranslation } from "react-i18next";
import { PresetColors } from "../../../../common/constants";
import { CommissionKind, CommissionKindCategory } from "../enums";
import { getCommissionKindCategory } from "../utils";

const getCommissionKindCategoryColor = (category: CommissionKindCategory) => {
  switch (category) {
    case CommissionKindCategory.RENEWAL:
      return PresetColors.GOLD;
    case CommissionKindCategory.SUBSEQUENT:
      return PresetColors.PURPLE;
    case CommissionKindCategory.BONUS:
      return PresetColors.GREEN;
    default:
      return PresetColors.GEEKBLUE;
  }
};

interface Props {
  kind?: CommissionKind;
  closable?: boolean;
  onClose?: (event?: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  label?: React.ReactNode;
  style?: React.CSSProperties;
}

export const CommissionKindTag = ({ kind, closable, onClose, label, style }: Props) => {
  const { t } = useTranslation();

  return kind || label ? (
    <Tag
      color={kind ? getCommissionKindCategoryColor(getCommissionKindCategory(kind)) : undefined}
      closable={closable}
      onClose={onClose}
      style={{ textAlign: "center", minWidth: 0, marginRight: 0, ...style }}
    >
      {kind ? t("commissions.batch.enums.commissionKind." + kind) : label}
    </Tag>
  ) : null;
};
